import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { type CartElement } from "./CartElement";
import B2CRequestCartItem from "./B2CRequestCartItem";
import { styled } from "~/common/mui";
import { t } from "i18next";

const PRODUCT_SIZE_S = "196px";
const CMT_SIZE_S = "416px";
const TABLE_HEADER_BORDER = 3;

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(2),
  [theme.breakpoints.up("tablet")]: {
    gap: 0,
  },
}));

const Header = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: `${PRODUCT_SIZE_S} ${PRODUCT_SIZE_S} ${CMT_SIZE_S}`,
  columnGap: theme.spacing(2.5),
  gridTemplateAreas: '"prod qty cmt"',
  padding: `${theme.spacing(1)} 0`,
  borderBottom: `${TABLE_HEADER_BORDER}px solid ${theme.palette.divider}`,
}));

const Product = styled("div")({ gridArea: "prod" });
const Quantity = styled("div")({ gridArea: "qty" });
const Comment = styled("div")({ gridArea: "cmt" });

interface B2CRequestCartListProps {
  items: CartElement[];
  className?: string;
}

const B2CRequestCartList = ({ items, className }: B2CRequestCartListProps) => {
  const isTablet = useIsMinTabletSize();
  return (
    <Root className={className}>
      {isTablet && (
        <Header>
          <Product>
            <b>{t("cartPage.table.header.product.title")}</b>
          </Product>
          <Quantity>
            <b>{t("cartPage.table.header.quantity.title")}</b>
          </Quantity>
          <Comment>
            <b>{t("cartPage.report.comment")}</b>
          </Comment>
        </Header>
      )}

      {items.map((item) => (
        <B2CRequestCartItem item={item} />
      ))}
    </Root>
  );
};

export default B2CRequestCartList;
